import { ChangeEvent, FC, useCallback, useEffect, useRef, useState, } from "react";
import { useDispatch } from "react-redux";

import clsx from "clsx";

import { AppDispatch } from "../../../redux/reducer/store";

import ArrowIcon from "../../../assets/icons/chevron.svg";

import styles from "./customMultiSelect.module.scss";

interface IMultiSelectOptions {
  isShowPlaceholder?: boolean;
  placeholder?: string;
  classNames?: boolean;
  isLongValue?: boolean;
  inputValues?: any;
  pageName?: string;
  resetPages?: () => void;
  setState?: any;
  reducer?: any;
  options?: any;
  activeOptions?: any;
  action?: any;
  offset?: any;
  limit?: number;
  name?: any;
  page?: string;
  setLoading?: any;
  disabled?: boolean;
  visible?: boolean;
  id?: number | string;
  lowerDown?: boolean;
  maxSelect?: number
};

const CustomMultiSelect: FC<IMultiSelectOptions> = ({
  isShowPlaceholder,
  activeOptions,
  placeholder,
  inputValues,
  resetPages,
  setLoading = ()=>{},
  classNames,
  isLongValue,
  lowerDown,
  disabled,
  pageName,
  setState,
  options,
  reducer,
  visible,
  action,
  offset,
  limit,
  name,
  page,
  id,
  maxSelect
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedOptions, setSelectedOptions] = useState<any[]>(
    (pageName === "unloadReportsPhotosModal")
      ? []
      : mapOptions(inputValues[name] || [], options)
  );
  const [defaultMultiselectValue, setDefaultMultiselectValue] =
    useState<string>(placeholder as string);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const inputRef = useRef<HTMLInputElement>(null);
  const selectRef = useRef<HTMLDivElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);

  const filteredOptions =
    (options && !(pageName === "createVacancy" || pageName === "days" || pageName === "mapTypes1" || pageName === "charts")) ?
      options
        ?.filter((option: { value: string, label: string }) => {
          return option?.label?.toLowerCase()?.includes(searchTerm?.toLowerCase())
        }
        )
        ?.sort((a: { value: string, label: string }, b: { value: string, label: string }) => a.label.localeCompare(b.label))
      : pageName === "mapTypes1"  || pageName === "charts" ?
        options
          ?.filter((option: { value: string, label: string }) => {
            return searchTerm ? option?.label?.toLowerCase()?.includes(searchTerm?.toLowerCase()) : option
          }
          )?.sort((a: { value: string, label: string }, b: { value: string, label: string }) => a.label.localeCompare(b.label))
        : options;

  const handleClickAcceptBtn = useCallback(() => {
    setIsPending(true);
    setIsOpen(false);
    if (
      pageName !== "unloadReportsPhotosModal" && pageName !== "createVacancy" &&
      pageName !== "integrationErrors"
    ) {
      resetPages && resetPages();
    }
  }, [pageName, resetPages]);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
  };

  useEffect(() => {
    if (isPending && pageName) {
      const filter =
        pageName === "integrationErrors" || pageName === "routes" || pageName === "type2" || pageName === "projects"
          ? selectedOptions.map((option: any) => ({
            id: option.value,
          }))
          : {
            [name]: !!selectedOptions.length
              ? selectedOptions.map((option: any) => {
                return (pageName === "visitSchedule" || pageName === "typeProject" || pageName === "mapTypes" || pageName === "mapContract" ||
                  pageName === "clientsList") &&
                  name !== "statuses"
                  ? {
                    id: option.value,
                    name: option.label
                  }
                  : option.value;
              })
              : [],
          };
      if (pageName === "unloadReportsPhotosModal" || pageName === "createVacancy") {
        setState(selectedOptions.map((elem: any) => elem.value));
      } else if (pageName === "unloadReportsPhotosModal1") {
        setState(selectedOptions.map((elem: any) => elem.value));
      } else if (pageName === "integrationErrors" || pageName === "routes" || pageName === "type2") {
        dispatch(
          reducer({
            ...inputValues,
            [name]: filter,
          })
        )
        // @ts-ignore
        if (pageName === "routes" || pageName === "type2" || pageName === "userReports" || pageName === "expiredReports" || pageName === "integrationErrors" || pageName === "clientsList" || pageName === "mapTypes" || pageName === "mapContract") {
          setLoading(true);
          dispatch(reducer({
            ...inputValues,
            [name]: filter,
          }))
          dispatch(action(limit, offset)).then(() => {
            setLoading(false);
          })
        } else {
          dispatch(action(limit, offset))
        }
      } else if (pageName === "selectCharts") {
        return
      } else {
        if (pageName === "routes" || pageName === "type2" || pageName === "userReports" || pageName === "expiredReports" || pageName === "integrationErrors" || pageName === "clientsList" || pageName === "mapTypes" || pageName === "mapContract") {
          setLoading(true);
          dispatch(reducer(filter));
          dispatch(action(limit, offset)).then(() => {
            setLoading(false);
          });
        } else if (id || id === 0) {
          if (pageName === 'charts') {
            dispatch(reducer({ id, value: filter }));
          } else {
            dispatch(reducer({
              ...inputValues,
              ...filter
            }));
          }
        } else {
          dispatch(reducer(filter));
          if (pageName === 'expiredReportsModal') {
            return
          }
          if (pageName === 'typeProject' || pageName === 'type1') {
            setLoading(true);
            dispatch(action(limit, offset)).then(() => {
              setLoading(false);
            })
          } else {
            setLoading(true)
            dispatch(action(limit, pageName === "visitSchedule" ? page : offset)).then(() => {
              setLoading(false)
            }
            )
          }

        }
      }
      setIsPending(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPending]
  );
  useEffect(() => {
    const handleClickOutsideModal = (e: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(e.target as Node) &&
        selectRef.current &&
        !selectRef.current.contains(e.target as Node)
      ) {
        setSelectedOptions(mapOptions((inputValues && inputValues[name]) ? inputValues[name] : [], options));
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideModal);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    };
    // eslint-disable-next-line
  }, [handleClickAcceptBtn, selectedOptions]);

  useEffect(() => {
    const trueValues = filteredOptions?.map((option: any) =>
      selectedOptions?.some((selectedOption) => {
        const result = selectedOption?.value?.name ? selectedOption.value.name === option.value.name : selectedOption.value === option.value;
        return result;
      })
    ).filter((value: any) => value);
    if ((pageName === 'type1' && name === 'routeStatusType') || name === 'actions') {
      setDefaultMultiselectValue(trueValues?.length > 0 ? [trueValues.length, options?.length].join("/") : (placeholder as string));
    } else if (pageName === 'mapContract') {
      setDefaultMultiselectValue(inputValues[name] ? inputValues[name][0].name : '');
    }  else if (pageName === 'expiredReportsModal') {
      setDefaultMultiselectValue(selectedOptions[0] ? selectedOptions[0].label : (placeholder as string));
    } else {
      setDefaultMultiselectValue(selectedOptions?.length ? [selectedOptions?.length, options?.length].join("/") : (placeholder as string));
    }
    // eslint-disable-next-line
  }, [selectedOptions, options?.length, placeholder]);

  useEffect(() => {
    if (modalRef.current && selectRef.current) {
      if (isOpen) {
        const modalRect = modalRef.current.getBoundingClientRect();
        // const selectRect = selectRef.current.getBoundingClientRect();
        if (modalRect.right >= windowWidth) {
          modalRef.current.style.left = `${(windowWidth - modalRect.left) - modalRect.width - 30}px`;
        }
        // if (selectRect.y + modalRect.height - 10 >= windowHeight) {
        //   modalRef.current.style.bottom = `${modalRect.height + 55}px`;
        // }
      }
    }
  }, [isOpen, windowWidth, windowHeight]);
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.select();
      inputRef.current.focus();
    }
  }, [isOpen]);
  const handleOpenModal = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionClick = (option: any) => {
    if (pageName === 'mapContract') {
      setSelectedOptions([option]);
    } else {
      const updatedOptions = selectedOptions?.filter(
        (selectedOption) => {
          if (selectedOption.value && selectedOption.value.name && option.value.name) {
            return selectedOption.value.name !== option.value.name;
          } else {
            return selectedOption.value !== option.value;
          }
        }
      );


      if (updatedOptions.length === selectedOptions.length) {
        if(maxSelect && selectedOptions.length === maxSelect) {
          return;
        } 
        setSelectedOptions([...selectedOptions, option]);
      } else {
        setSelectedOptions(updatedOptions);
      }
     
    }
  };
  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e?.target?.value);
  };
  const handleSelectAll = (e: any) => {
    e.preventDefault()
    if (filteredOptions.length) {
      setSelectedOptions(filteredOptions);
    } else {
      setSelectedOptions(options);
    }
  };
  const handleDeselectAll = (e: any) => {
    e.preventDefault()
    setSelectedOptions([]);
  };

  function mapOptions(values: any, options: any) {
    const condition =
      pageName === "integrationErrors" ||
      pageName === "routes" ||
      pageName === "type2" ||
      pageName === "visitSchedule" ||
      pageName === "clientsList" ||
      pageName === "regionsExt" ||
      pageName === "typeProject" ||
      pageName === "mapTypes" ||
      pageName === "mapContract";
    return values.map((elem: any) => {
      return {
        value: condition ? elem.id : elem,
        label: condition
          ? options.find((option: any) => option.value === elem.id)?.name
          : options.find((option: any) => option.value === elem)?.label,
      };
    });
  }

  useEffect(() => {
    if (activeOptions) {
      const updatedSelectedOptions = activeOptions.map((option: any) => {
        if (name === 'vsv' || name === 'sv' || name === 'project') {
          return { value: option.id, label: option.name };
        } else if (pageName === 'vacancy'|| pageName === 'mapContract') {
          if (option.name) {
            return { value: option.id, label: option.name }
          }
          return { value: option }
        } else if (pageName === 'createVacancy' || pageName === 'mapTypes1' || pageName === 'charts') {
          if (option.name) {
            return { value: option, label: option.name }
          }
          return { value: option }
        } else {
          return {
            value: (name === 'status' || name === 'actions') ? option : (option ? (option.value || option.id) : null)
          };
        }
      });
      setSelectedOptions(updatedSelectedOptions);
    }
  }, [activeOptions, name, pageName]);

  useEffect(() => {
    if ((pageName === 'mapTypes1' || pageName === 'charts') && !inputValues[name]) {
      setSelectedOptions([]);
    }
    // eslint-disable-next-line
  }, [inputValues]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  return (
    <div className={clsx(styles.select__wrapper, lowerDown ? styles.select__wrapper_down : '', visible && styles.select__wrapper_hidden, isLongValue ? styles.long : '' )}>
      <span
        className={clsx(
          styles.custom__floating_placeholer,
          selectedOptions.length >= 1 &&
          isShowPlaceholder &&
          styles.active__floating_placeholder,
          (pageName === 'vacancy' || pageName === 'type2') && styles.active__floating_placeholder_top,
          (pageName === 'selectCharts' || pageName === 'mapTypes' || pageName === 'mapTypes1' || pageName === 'mapContract' || pageName === 'charts') && styles.active__floating_placeholder_top1,
        )}
      >
        {placeholder}
      </span>
      <div
        className={clsx(styles.input__block, name === "actions" && styles.fullWidth)}
        onClick={handleOpenModal}
        ref={selectRef}
      >
        <input
          placeholder={defaultMultiselectValue}
          className={clsx(!classNames ? styles.input : (styles.input, styles.error))}
          type="text"
          readOnly
          disabled={disabled && disabled}
        />
        <img
          className={clsx(styles.icon, name === "actions" && styles.icon__left, disabled && styles.icon__disabled)}
          src={ArrowIcon} alt="arrow" />
      </div>
      {isOpen && (
        <div className={styles.modal} ref={modalRef}>
          {!(name === "actions") && <input
            onChange={handleSearchChange}
            className={styles.search}
            placeholder="Поиск..."
            value={searchTerm}
            ref={inputRef}
            type="text"
          />}
          {!maxSelect && pageName !== "mapContract" && <div className={styles.btns}>
            <button className={styles.btn} onClick={handleSelectAll}>Выбрать все</button>
            <button className={styles.btn} onClick={handleDeselectAll}>Убрать все</button>
          </div>}

          {maxSelect && <div className={styles.maxContainer}>
            <button className={clsx(styles.btn, styles.btnFull)} onClick={handleDeselectAll}>Убрать все</button>
            <span className={styles.max}>Можно выбрать: {maxSelect}</span>
          </div>}
          <ul className={styles.list}>
            {filteredOptions &&
              filteredOptions?.map((option: any, index: number) => (
                <li
                  key={index}
                  className={`${styles.elem} ${selectedOptions?.some(
                    (selectedOption) => {
                      return selectedOption?.value?.name
                        ? selectedOption.value.name === option.value.name
                        : selectedOption.value === option.value
                    }
                  )
                    ? styles.active__elem
                    : ""
                    }`}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.label}
                </li>
              ))}
          </ul>
          <button className={styles.accept__btn} onClick={handleClickAcceptBtn}>
            Применить
          </button>
        </div>
      )}
    </div>
  );
}
  ;

export default CustomMultiSelect;
